import { createSelector } from 'reselect';
import Utils from 'yoda-core-components/lib/helpers/Utils/Utils';
import { selectFeatureFlags, selectPreferences, selectReqHeaders } from './ContextSelector';
import { plccBanner } from '../common/Constants';

export const DEFAULTS = {};

const isPlccBannerEnabled = (featureFlags, preferences, reqHeaders) =>
    Utils.isFeatureEnabled(
        featureFlags,
        preferences,
        reqHeaders,
        // featureflag,        cookieName            headerName
        'enablePaymentsPLCCBanner',
        plccBanner.cookieFlagName,
        plccBanner.headerFlagName
    );

// FF
export const selectPlccBannerThrottleFF = createSelector(
    [selectFeatureFlags, selectPreferences, selectReqHeaders],
    isPlccBannerEnabled
);
